import bdServices125 from '../bd-services125'
import bdServices from '../bd-services'

const ReportesServices = {}

ReportesServices.getActividad = async (idAct) => {
  const currentUrl = window.location.hostname

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`servidores/reportesApp/getActividad.php?id=${idAct}`)
      .then(res => res.data[0])
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`servidores/reportesApp/getActividad.php?id=${idAct}`)
      .then(res => res.data[0])
      .catch(e => console.error(e))
    return data
  }
}

ReportesServices.getActualizaciones = async (idAct) => {
  const currentUrl = window.location.hostname

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`servidores/reportesApp/getActualizaciones.php?id=${idAct}`)
      .then(res => res.data[0])
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`servidores/reportesApp/getActualizaciones.php?id=${idAct}`)
      .then(res => res.data[0])
      .catch(e => console.error(e))
    return data
  }
}

export default ReportesServices


// WEBPACK FOOTER //
// ./src/services/reportes/reportes.js